<template>
	<div class="balance-info-container">
		<h1>
			{{ title }}
		</h1>
		<div class="header-info">
			<div v-if="email" class="account-info account-info--email">
				{{ email }}
			</div>

			<div v-if="showSwitchAccountButton" class="account-info">
				<button class="btn-logout text-uppercase" @click="switchAccount">
					{{ $t('checkout.switch-account-logout') }}
					<svgIcon icon-holder-class="icon-faq" icon-id="icon-page-right-blue" />
				</button>
			</div>

			<div v-if="showBalance && (!isInGame || (isInGame && isDisplayBalance))" class="balance">
				<span>
					{{ $t(`checkout.${isInGame ? 'current-balance' : 'balance'}`) }}
					<strong><currency v-if="totalBalance >= 0" :code="currency" :value="totalBalance"/></strong>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import config from '@/config/environment-config';
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';
import currency from '@/components/common/currency';

export default {
	name: 'BalanceInfo',
	components: {
		svgIcon,
		currency,
	},
	props: {
		title: {
			type: String,
			default: '',
		},
		showSwitchAccount: {
			type: Boolean,
			default: false,
		},
		isInGame: {
			type: Boolean,
			default: false,
		},
		showBalance: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {};
	},
	computed: {
		email() {
			return this.$store.state.userEmail;
		},
		currency() {
			return this.$store.state.accountBalance.currency;
		},
		showSwitchAccountButton() {
			return this.showSwitchAccount && this.$store.state.appType === 'web' && this.email;
		},
		totalBalance() {
			return this.$store.state.accountBalance.total;
		},
		isDisplayBalance() {
			return this.$store.state.accountBalance.isDisplayBalance;
		},
	},
	methods: {
		switchAccount() {
			this.$a2s.click('logout', {
				objectTag: 'login_start',
			});
			dataLayer.push({
				event: 'Add Balance Switch Account Click',
			});

			let urlBase;
			if (process.env.VUE_APP_ENV === 'local') {
				urlBase = `https://${window.location.hostname.replace('localhost.', '')}`;
			} else {
				urlBase = window.location.origin;
			}
			window.location.href = `${urlBase}/account/logout?return_url=${
				config[process.env.VUE_APP_ENV][environment.region].wallet
			}/${this.$i18n.locale}/add-balance`;
		},
	},
};
</script>

<style lang="less" scoped>
.balance-info-container {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: flex-end;
	border-bottom: 1px solid #383838;
	padding-bottom: 11px;
	h1,
	.account-info--email {
		color: #fff;
	}
	h1 {
		font-family: KlavikaNX-Medium;
		font-size: 26px;
		font-weight: 700;
		text-transform: uppercase;
		margin: 0;
		@media (min-width: 600px) {
			padding-bottom: 4px;
		}
	}
	.account-info--email {
		font-weight: bold;
	}
	.header-info {
		padding-bottom: 6px;
		margin-left: auto;
		@media (max-width: 599px) {
			flex: 0 0 100%;
			max-width: 100%;
			margin-top: 8px;
			padding-bottom: 8px;
			.balance {
				> span {
					display: block;
					&:first-child {
						padding-right: 0;
						padding-bottom: 4px;
						&:after {
							content: none;
						}
					}
				}
			}
		}
	}
}
.header-info {
	font-size: 14px;
	font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
	@media (min-width: 600px) {
		text-align: right;
	}
}
.btn-logout {
	font-size: 12px;
	line-height: 1;
	display: inline-flex;
	align-items: center;
	position: relative;
	color: #0077ff;
	font-weight: bold;
	background-color: transparent;
	border: none;
	margin: 0;
	padding: 7px 0px 4px 0px;
	svg {
		width: 10px;
		height: 10px;
		transition: 0.3s ease;
		opacity: 0.7;
		margin-left: 5px;
	}
	&:hover {
		color: #4ca1ff;
		svg {
			opacity: 1;
		}
	}
}
.balance {
	font-size: 14px;
	margin-top: 10px;
	> span {
		display: inline-block;
		&:first-child {
			padding-right: 15px;
			&:after {
				padding-left: 19px;
				color: #4c4c4c;
				content: '|\A0';
				font-size: 13px;
			}
		}
		&:last-child {
			padding-right: 0px;
			&:after {
				content: none;
			}
		}
	}
	strong {
		padding-left: 5px;
		color: #eda03b;
	}
}
</style>
